export default "__VITE_ASSET__CtyxR0EK__"